window.clearFilters = function() {
    document.querySelectorAll('.js-filters input').forEach(input => {
        input.checked = false;
    });
};